import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ThemeService } from './core/services/theme.service';
import { AppActivityIndicatorComponent } from './layout/app-activity-indicator.component';
import { ConfirmDialogComponent } from './layout/confirm-dialog.component';
import { ToastContainerComponent } from './layout/toast-container.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppActivityIndicatorComponent, ConfirmDialogComponent, ToastContainerComponent],
  templateUrl: './app.html'
})
export class App {
  protected readonly theme = inject(ThemeService);
}
